<form (submit)="saveData()">
  <label>Name</label>
  <input type="text" name="studentName" required [(ngModel)]="stuName" >
  <br />
  <label>Designation</label>
  <input type="text" name="sudentDesignation" required [(ngModel)]="stuDesignation" >
  <br />
  <button>Add</button>
</form>
<ul class="list">
  <li *ngFor="let data of dataObj">
    <h2>{{data.name}}</h2>
    <p>{{data.designation}}</p>
  </li>
</ul>
